import { MapfreButtonComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, Input, OnInit } from '@angular/core';
import { AcmicService } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreButtonComponent],
  selector: 'app-upload-documents-sidebar',
  templateUrl: './upload-documents-sidebar.component.html',
  styleUrls: ['./upload-documents-sidebar.component.scss'],
})
export class UploadDocumentsSidebarComponent implements OnInit {
  @Input() claimId: string;
  isAcmic=false;
  constructor(
    private acmicService:AcmicService
  ){

  }
   ngOnInit(): void {
    this.isAcmic = this.acmicService.isACMIC();
  }
 
}
